<template>
  <v-toolbar flat color="white" density="compact">
    <v-toolbar-title class="text-primary">{{ label }}</v-toolbar-title>
    <v-spacer/>
    <base-action-button v-if="!preview && !isDisabled" @action="createLink">
      <template #prepend><PhPlus style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
      {{ $store.getters.translate("create") }}
    </base-action-button>
  </v-toolbar>
  <v-divider/>
  <v-list v-if="links && links.length > 0" density="compact">
    <v-list-item v-for="(link, index) in links" :key="index" color="primary" class="ml-1">
      <v-list-item-title>
        <a class="sm-bold" v-if="link.url" :href="link.url" target="_blank">{{ link.name }}</a>
        <span v-else-if="!preview && !isDisabled" @click.stop="editLink(link)">{{ link.name }}</span>
        <span v-else>{{ link.name }}</span>
      </v-list-item-title>
      <v-list-item-subtitle>
        <span class="tiny-normal">{{ link.creator + ' on ' + moment(link.created_at).format("DD-MM-YYYY HH:mm") }}</span>
      </v-list-item-subtitle>
      <template v-if="!preview && !isDisabled" #append>
        <v-list-item-action>
          <v-menu>
            <template #activator="{ props }">
              <v-btn elevation="0" icon v-bind="props">
                <PhDotsThreeVertical size="24" style="cursor: pointer;"/>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="editLink(link)">
                <template #prepend><PhPencilSimpleLine size="24"/></template>
                <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('edit') }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="deleteLink(link)">
                <template #prepend><PhTrash size="24"/></template>
                <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('delete') }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list-item-action>
      </template>
    </v-list-item>
  </v-list>
  <div class="reg-normal text-primary ml-5 mt-3" v-else>{{ $store.getters.translate("nothing_found") }}</div>
  <base-create-dialog modal_name="create_external_link" ref="create_external_link" :page="page" @refresh="load"/>
  <base-edit-dialog modal_name="edit_external_link" ref="edit_external_link" :page="page" :internal_model="true" @refresh="load"/>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseActionButton from "./BaseActionButton";
import {PhDotsThreeVertical, PhPencilSimpleLine, PhPlus, PhTrash} from "@phosphor-icons/vue";
import BaseCreateDialog from "./BaseCreateDialog";
import BaseEditDialog from "./BaseEditDialog";

export default {
  components: {BaseEditDialog, BaseCreateDialog, PhTrash, PhPencilSimpleLine, PhDotsThreeVertical, PhPlus, BaseActionButton},
  props: ["model_type", "model_id", "label", "preview", "isDisabled"],
  data() {
    return {
      page: helpFunctions.pages.externallinks,
      links: [],
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      if(this.model_id) {
        this.links = await helpFunctions.getCustomRoute(this.$toast, this.page.name + "?model_type=" + this.model_type + "&model_id=" + this.model_id);
      }
    },
    createLink() {
      this.$refs.create_external_link.load();
      this.$refs.create_external_link.record.model_id = this.model_id;
      this.$refs.create_external_link.record.model_type = this.model_type;
    },
    editLink(link) {
      this.$refs.edit_external_link.load(link.id);
    },
    deleteLink(link) {
      this.$confirm(this.$store.getters.translate("delete_confirmation")).then(async (res) => {
        if (res) {
          await helpFunctions.deleteModel(this.$toast, this.page.name, link.id);
          await this.load();
        }
      });
    },
  },
  watch: {
    model_id: {
      handler() {
        this.load();
      },
    },
  },
};
</script>

<style scoped>
.v-toolbar-title >>> .v-toolbar-title__placeholder {
  overflow: visible !important;
}
</style>